import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import {CryptoAddress} from "@/models/finance/crypto";
import axios from "axios";

export class DepositUsdcTransferModel extends WebFormModel {

  initStatus = new RemoteRequestState()
  recreateStatus = new RemoteRequestState()
  selectedAddress: CryptoAddress | null = null;

  addresses = []
  accounts = []

  options = {
    avail: false
  }

  values = {
    address: '',
    account: ''
  }

  loadModel() {
    this.initStatus.loadStart()
    return axios.post('/webapi/finance/usdcdeposit', {
      call: 'loadModel'
    }).then(result => {
      this.initStatus.loadEnd()
      this.accounts = result.data.model.options.accounts
      if (this.accounts.length > 0) {
        this.values.account = this.accounts[0].number
      }
      this.addresses = result.data.model.options.addresses.map((obj) => CryptoAddress.createFromData(obj))
      this.options.avail = result.data.model.options.avail
      if (this.options.avail && (this.addresses.length == 0)) {
        throw new Error('address not found')
      }
      if (this.addresses.length > 0) {
        this.values.address = this.addresses[0].address
        this.selectedAddress = this.addresses[0]
      }
      return result.data.model
    }).catch(err => {
      this.initStatus.loadError()
      throw err
    })
  }

}



